import { ProjectsState, ProjectsAction } from "../../types";

export const reducer = (state: ProjectsState, action: ProjectsAction): ProjectsState => {
  switch (action.type) {
    case "addProject": {
      return {
        ...state,
        projects: [...state.projects, action.payload],
      };
    }

    case "setCurrentProject": {
      return { ...state, currentProject: action.payload };
    }

    default:
      return state;
  }
};

export const initialState: ProjectsState = {
  projects: [],
  currentProject: null,
};
